import React from 'react';
import { LottoCombinations } from '../../../interfaces/LottoState';

export interface LottoContextProps {
  selectedEvents : { code: number, scheduled: number, selected: boolean }[],
  selectedSpecialEvents: { code: number, scheduled: number, selected: boolean}[],
  selectedMarket: {
    marketCode: string,
    marketTypeId: number,
    code?: string,
    name: string,
    predictionCount?: number,
    outcomes:{ name: string, value: number, code: number }[],
    header?: number,
   specifiers:{name: string, value:string}[]
    typeCode: number
  }
  combinations: LottoCombinations,
  selectedNumbers: {
    number: number,
    type: string,
    isBanker: boolean,
    color: string
  }[],
  usedNumbers: {
    number: number,
    type: string,
    isBanker: boolean,
    color: string
  }[],
  tab: number,
  retailStake:number,
  isLoading: boolean,
  selectedNumbersForEachMarket:{},
  setSelectedEvents: Function,
  setUsedNumbers: Function,
  setSelectedSpecialEvents: Function,
  setSelectedMarket: Function,
  setselectedNumbers: Function,
  setTab: Function,
  setQuickBet: Function,
  setCombinations: Function,
  setRetailStake: Function,
  setNumbersForEachMarket: Function,
  setIsLoading: Function,
  setIsManualSelection: Function,
  quickBet: boolean,
  isManualSelection:boolean,
}

const LottoContext = React.createContext<Partial<LottoContextProps>>({
  selectedEvents: [],
  selectedSpecialEvents: [],
  selectedMarket: null,
  selectedNumbers: [],
  tab: 500,
  combinations: {
    odds: 0,
    rankedNumbers: [],
    repetitionsCount: 0,
    anyNumbers: [],
    permutationsCount: 0,
    permutations: [],
    maximumProfit: 0,
    numbersToPredictCount: 0
  },
  retailStake: 10,
  isLoading: false,
  usedNumbers: [],
  setSelectedEvents : () => {},
  setUsedNumbers: () => {},
  setSelectedMarket: () => {},
  setselectedNumbers: () => {},
  setTab: () => {},
  setQuickBet: () => {},
  setCombinations: () => {},
  setRetailStake: () => {},
  setNumbersForEachMarket: () => {},
  setSelectedSpecialEvents: () => {},
  setIsLoading: () => {},
  quickBet: false,
  isManualSelection: false,
  setIsManualSelection: () => {}
});

export default LottoContext;
